import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import {
    Button, ListGroup, ListGroupItem, Progress, Modal, ModalBody, Input, FormGroup, Label, NavLink, Badge
} from 'reactstrap';
import { clearSession } from '../../session';
import Swal from 'sweetalert2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default class HeroImages extends React.Component {
    constructor(props) {
        super(props);
        this.state = { images: [], loading_data: false, addYoutubeVideo: false }
    }
    componentDidMount() {
        this.loadIndicator(true);
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_hero_images", Qs.stringify({
            token: session.ch_admin_token
        })).then(res => {
            this.loadIndicator(false);

            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let images = res.data.data;
                this.setState({ images: images });
            }
        });
    }

    handleHeroAction(action_name, value) {
        let images = this.state.images;
        if (action_name === "delete") {
            let session = window.localStorage;
            images.splice(value, 1);
            this.loadIndicator(true);

            axios.post(session.ch_action_url + "/action/save_hero_images", Qs.stringify({
                token: session.ch_admin_token,
                images: JSON.stringify(images)
            })).then(res => {
                this.loadIndicator(false);

                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    this.setState({ images: images });
                }
            });
        }
        else if (action_name === "move_up") {
            let from_index = value;

            let to_index = from_index - 1;
            let cutOut = images.splice(from_index, 1)[0]; // cut the element at index 'from'
            images.splice(to_index, 0, cutOut);
            this.setState({ images: images });
        }
        else if (action_name === "move_down") {
            let from_index = value;

            let to_index = from_index + 1;

            let cutOut = images.splice(from_index, 1)[0]; // cut the element at index 'from'
            images.splice(to_index, 0, cutOut);
            this.setState({ images: images });

        }
        else if (action_name === "save_hero_images") {
            this.loadIndicator(true);

            let session = window.localStorage;
            axios.post(session.ch_action_url + "/action/save_hero_images", Qs.stringify({
                token: session.ch_admin_token,
                images: JSON.stringify(images)
            })).then(res => {
                this.loadIndicator(false);

                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    Swal.fire(
                        'Operation Done!',
                        "Success",
                        'success');
                    this.setState({ images: images });
                }
            });
        }
        else if (action_name === "add_video_link") {
            let session = window.localStorage;
            let link = document.getElementById("youtubelink").value;
            let parser = new DOMParser();
            let htmlDoc = parser.parseFromString(link, 'text/html');
            let doms=htmlDoc.getElementsByTagName('iframe');
            let v_link=doms[0].getAttribute("src");
            axios.post(session.ch_action_url + "/action/add_single_hero_image", Qs.stringify({
                token: session.ch_admin_token,
                image: v_link
            })).then(res => {
                this.loadIndicator(false);

                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let images = this.state.images;
                    images.push(link);
                    this.setState({ images: images, addYoutubeVideo: false });
                }
            });
        }
    }

    /**
 * 图片按宽高比例进行自动缩放
 * @param ImgObj
 *     缩放图片源对象
 * @param maxWidth
 *     允许缩放的最大宽度
 * @param maxHeight
 *     允许缩放的最大高度
 * @usage 
 *     调用：<img src="图片" onload="javascript:DrawImage(this,100,100)">
 */
    getDrawImage(ImgObj, maxWidth, maxHeight) {
        var image = new Image();
        //原图片原始地址（用于获取原图片的真实宽高，当<img>标签指定了宽、高时不受影响）
        image.src = ImgObj.src;
        // 用于设定图片的宽度和高度
        var tempWidth;
        var tempHeight;

        if (image.width > 0 && image.height > 0) {
            //原图片宽高比例 大于 指定的宽高比例，这就说明了原图片的宽度必然 > 高度
            if (image.width / image.height >= maxWidth / maxHeight) {
                if (image.width > maxWidth) {
                    tempWidth = maxWidth;
                    // 按原图片的比例进行缩放
                    tempHeight = (image.height * maxWidth) / image.width;
                } else {
                    // 按原图片的大小进行缩放
                    tempWidth = image.width;
                    tempHeight = image.height;
                }
            } else {// 原图片的高度必然 > 宽度
                if (image.height > maxHeight) {
                    tempHeight = maxHeight;
                    // 按原图片的比例进行缩放
                    tempWidth = (image.width * maxHeight) / image.height;
                } else {
                    // 按原图片的大小进行缩放
                    tempWidth = image.width;
                    tempHeight = image.height;
                }
            }
            // 设置页面图片的宽和高
            ImgObj.height = tempHeight;
            ImgObj.width = tempWidth;
            // 提示图片的原来大小
            ImgObj.alt = image.width + "×" + image.height;
            return ImgObj;
        }
    }

    handleAddNewImage() {
        let final_this = this;
        let fileInput = document.getElementById('upload_highlight_image');
        if (fileInput.files != null && fileInput.files.length === 1) {
            let reader = new FileReader();
            reader.onload = function (e) {
                let image = new Image();
                image.src = e.target.result;
                image.onload = function () {
                    let height = this.height;
                    let width = this.width;
                    let tempImage = final_this.getDrawImage(image, 1280, 720);
                    let mainCanvas = document.createElement("canvas");
                    mainCanvas.width = tempImage.width;
                    mainCanvas.height = tempImage.height;
                    var ctx = mainCanvas.getContext("2d");
                    ctx.drawImage(tempImage, 0, 0, mainCanvas.width, mainCanvas.height);
                    let image_64 = mainCanvas.toDataURL("image/jpeg");
                    mainCanvas.remove();
                    let session = window.localStorage;
                    final_this.loadIndicator(true);

                    axios.post(session.ch_action_url + "/action/add_single_hero_image", Qs.stringify({
                        token: session.ch_admin_token,
                        image: image_64
                    })).then(res => {
                        final_this.loadIndicator(false);

                        if (res.data.status === -1) {
                            clearSession();
                        }
                        else if (res.data.status === 0) {
                            Swal.fire(
                                'Operation Failed!',
                                res.data.info,
                                'error');
                        }
                        else {
                            let images = final_this.state.images;
                            images.push(image_64);
                            final_this.setState({ images: images });
                        }
                    });
                };
                fileInput.value = "";
            };
            reader.readAsDataURL(fileInput.files[0]);
        }
        else {
            Swal.fire(
                'Operation Failed!',
                "You have not select image!",
                'error');
            return;
        }
    }

    loadIndicator(flag) {
        let indicator = document.getElementById("admin_data_loading_bar_indicator");
        if (flag) {
            indicator.style.display = "block";
        }
        else {
            indicator.style.display = "none";
        }
    }

    handleShowUploadImage(image_id) {
        //this.setState({ image_id: image_id });
        let fileInput = document.getElementById('upload_highlight_image');
        fileInput.click();
    }

    isStringImage(str) {
        if (str.startsWith("data:image") || str.endsWith(".png") || str.endsWith(".jpeg") || str.endsWith(".jpg") || str.endsWith(".gif")) {
            return 1;
        }
        else {
            return 0;
        }
    }

    render() {
        return <Fragment>
            <div className="p-2 pl-2 pr-4">
                <input type="file" style={{ display: "none" }} id="upload_highlight_image" accept="image/png, image/gif,image/jpg, image/jpeg, image/bmp, image/x-icon" onChange={(e) => this.handleAddNewImage()} />
                <div className="mb-3 mt-2 card" style={{ maxWidth: "800px", margin: "auto" }}>

                    <div className="d-flex justify-content-between align-items-center p-2">
                        <div className="d-flex">
                            <Button size="sm" className="mr-2" color="first" onClick={e => this.setState({ addYoutubeVideo: true })}>Add Youtube</Button>
                            <Button size="sm" className="mr-2" color="first" onClick={e => this.handleShowUploadImage()}>Add Image</Button>
                        </div>
                        <Button size="sm" className="ml-2" color="first" onClick={e => this.handleHeroAction("save_hero_images")}>Save</Button>
                    </div>
                    <div className="mb-2" id="admin_data_loading_bar_indicator" style={{ display: "none" }}>
                        <Progress value="100" animated className="progress-animated-alt progress-lg" color="warning">{"Operation Processing, Please Wait ...."}</Progress>
                    </div>
                    <ListGroup flush>
                        {this.state.images != null && this.state.images.length > 0 && this.state.images.map((ins, ins_index) => (
                            <ListGroupItem className="d-flex justify-content-between align-items-center py-3">
                                <div name="hero_image">
                                    {this.isStringImage(ins) === 1 && <img src={ins} alt="" style={{ height: "200px" }} />}
                                    {this.isStringImage(ins) === 0 &&
                                        <iframe className="p-1" height="200" src={ins} style={{ border: "none" }}></iframe>}
                                </div>
                                <div className="align-items-center" style={{ cursor: "pointer" }}>
                                    {ins_index > 0 && <FontAwesomeIcon icon={['fas', 'arrow-circle-up']} style={{ fontSize: "20px" }} onClick={(e) => this.handleHeroAction("move_up", ins_index)} />}
                                    {ins_index < (this.state.images.length - 1) && <FontAwesomeIcon style={{ fontSize: "20px" }} icon={['fas', 'arrow-circle-down']} onClick={(e) => this.handleHeroAction("move_down", ins_index)} className="ml-2" />}
                                    <FontAwesomeIcon icon={['fas', 'trash']} style={{ fontSize: "20px" }} className="ml-2" onClick={(e) => this.handleHeroAction("delete", ins_index)} />
                                </div>
                            </ListGroupItem>
                        ))}
                    </ListGroup>
                </div>
            </div>

            <Modal zIndex={2000} isOpen={this.state.addYoutubeVideo}>
                <div className="modal-header">
                    <h5 className="modal-title">Add Youtube Video</h5>
                    <div>
                        <Button color="primary" className="ml-2" size="sm" onClick={() => this.handleHeroAction("add_video_link")}>Confirm</Button>
                        <Button color="dark" className="ml-2" size="sm" onClick={(e) => this.setState({ addYoutubeVideo: false })}>Close</Button>
                    </div>
                </div>
                <ModalBody>
                    <FormGroup>
                        <Label htmlFor="youtubelink">Youtube Link</Label>
                        <Input type="text" name="youtubelink" id="youtubelink"
                            placeholder="video link" />
                    </FormGroup>
                </ModalBody>
            </Modal>

        </Fragment>
    }

}